export const fonts = {
  light: 'font-family: "Light", Helvetica, sans-serif',
  bold: 'font-family: "Bold", Helvetica, sans-serif'
};
